import React, { useState , useEffect, Suspense, useRef } from "react";
import { scriptControlHeight, mediaControlHeight, setUserDataFn, logOut } from "./ApiCenter/API_GET";
import { BrowserRouter as Router, Route, Routes, Outlet } from 'react-router-dom'
import './App.css';
import { MenuLeft } from "./MenuLeft/MenuLeft";
import { ProfileSettings } from "./pages/profile/profileSettings";
import {InfoProvider}  from './ApiCenter/AM_BackGroundOP';
import Protected from './Protected';
/* projects */
import { ProjectsShow } from "./pages/Projects/01_Projects";
import { ProjectBreakdownfakeLink } from "./pages/Projects/BreakDownSupport/04_02_ProjectBreakdown_fakeLink";
import $ from "jquery";
import VideoPlayer from "./ApiCenter/AudioMateVPlayer";
import { registerLicense } from '@syncfusion/ej2-base';
import { PronunciationsContextProvider } from './pages/Projects/PronunciationContext';
import { ActorScriptContextProvider } from './pages/Projects/ActorScriptContext';
import { SpellCheckContextProvider } from './pages/Projects/SpellCheckContext';
import { FloatingWindowLauncher } from './ApiCenter/FloatingWindow';
import { NotFound } from './NotFound';
/* electron mode */
import { AMKRAST } from './ApiCenter/ELECTRON/AM_ReaperConnection';

import { Navigate, useLocation, useParams } from "react-router-dom";

const Header = React.lazy(() => import("./Header/Header").then(module => ({ default: module.Header })));
//const ProjectOverview = React.lazy(() => import('./pages/Projects/04_01_ProjectOverview').then(module => ({ default: module.ProjectOverview })));
const ProjectsOverview = React.lazy(() => import('./pages/Projects/ProjectOverview/04_01_ProjectOverview_module').then(module => ({ default: module.ProjectsOverview })));
const ProjectsBD = React.lazy(() => import('./pages/Projects/04_02_ProjectBreakdown'));
const ProjectBDBuilder = React.lazy(() => import('./pages/Projects/04_07_ProjectBDBuilder'));
const ProjectActors = React.lazy(() => import('./pages/Projects/04_08_ProjectActors'));
const ProjectsScript = React.lazy(() => import('./pages/Projects/04_03_ProjectScriptTable').then(module => ({ default: module.ProjectsScript })));
const DeliveryDashboard = React.lazy(() => import('./pages/Projects/04_11_DeliveryDashboard'));
const RecordingSessions = React.lazy(() => import('./pages/Projects/04_10_RecordingSessions'));
const ActorScriptWindow = React.lazy(() => import('./pages/Projects/04_09_ActorScript'));
const AgendaWindow = React.lazy(() => import('./pages/Projects/AgendaWindow'));
const PronunciationGlossaries = React.lazy(() => import('./pages/Projects/01_Projects_Pronunciations'));
const ProjectScriptExcel = React.lazy(() => import('./pages/Projects/04_04_ProjectScriptExcel').then(module => ({ default: module.ProjectScriptExcel })));
const ProjectGant = React.lazy(() => import('./pages/Projects/04_05_ProjectGantChart').then(module => ({ default: module.ProjectGant })));
const TrelloProduction = React.lazy(() => import('./pages/Projects/04_06_Trello').then(module => ({ default: module.TrelloProduction })));
const MediaLibrary2 = React.lazy(() => import('./pages/Projects/04_08_MediaFiles_2'));
const FileManager = React.lazy(() => import('./pages/Projects/FileManager/FileManager'));
const PlayerDetachableAudio = React.lazy(() => import("./ApiCenter/DetachableAudioPLayer"));
const PlayerDetachableVideo = React.lazy(() => import("./ApiCenter/DetachableVideoPlayer"));
const UploadAssets = React.lazy(() => import('./pages/FileTransfer/UploadAssets'));
const DowloadAssets = React.lazy(() => import('./pages/FileTransfer/DowloadAssets'));
const AdminHomePage = React.lazy(() => import('./Admin/ResourceManager_TabComponent').then(module => ({ default: module.AdminHomePage })));
const ApplicationUsers = React.lazy(() => import('./Admin/ResourceManager_ApplicationUsers'));
const ProductionUsers = React.lazy(() => import('./Admin/ResourceManager_Actors'));
const GroupsManagements = React.lazy(() => import('./Admin/ResourceManager_Groups'));
const RecordingStudios = React.lazy(() => import('./Admin/ResourceManager_RecordingStudios').then(module => ({ default: module.RecordingStudios })));
const BankHolidays = React.lazy(() => import('./Admin/ResourceManager_BankHolidays').then(module => ({ default: module.BankHolidays })));
const AMTasksType = React.lazy(() => import('./Admin/ResourceManager_TasksType').then(module => ({ default: module.AMTasksType })));
const AMSites = React.lazy(() => import('./Admin/ResourceManager_Sites').then(module => ({ default: module.AMSites })));
const AMClients = React.lazy(() => import('./Admin/ResourceManager_Clients').then(module => ({ default: module.AMClients })));
const AMLanguages = React.lazy(() => import('./Admin/ResourceManager_Languages').then(module => ({ default: module.AMLanguages })));
const AMFranchises = React.lazy(() => import('./Admin/ResourceManager_Franchises').then(module => ({ default: module.AMFranchises })));
const AMRoles = React.lazy(() => import('./Admin/ResourceManager_Roles').then(module => ({ default: module.AMRoles })));


const SchedulerContainer = React.lazy(() => import('./Admin/Scheduler/SchedulerContainer').then(module => ({ default: module.SchedulerContainer })));
const SchedulerContainer2 = React.lazy(() => import('./Admin/Scheduler2/SchedulerContainer').then(module => ({ default: module.SchedulerContainer })));
const QATags = React.lazy(() => import('./Admin/QATags').then(module => ({ default: module.QATags })));
const RolesPermission = React.lazy(() => import('./Admin_superior/RolesPermission').then(module => ({ default: module.RolesPermission })));
const ChatGPT = React.lazy(() => import('./pages/Projects/ChatGPT'));
const S3Manager = React.lazy(() => import('./Admin/AudioManager/S3Manager').then(module => ({ default: module.S3Manager })));
//const ElectronStreamViewer = React.lazy(() => import('./Admin/AudioManager/Electron').then(module => ({ default: module.ElectronStreamViewer })));
const AMLogs = React.lazy(() => import('./Admin/ResourceManager_Logs').then(module => ({ default: module.AMLogs })));
const XLOCApi = React.lazy(() => import('./pages/Projects/XLOCApi'));
const KPIs = React.lazy(() => import('./pages/Projects/KPIs'));
const MyDashboard = React.lazy(() => import('./pages/Projects/05_MyDashboard'));
const ExcelModule = React.lazy(() => import('./pages/SyncFusionTest/SpreedSheet').then(module => ({ default: module.ExcelModule })));
const ApplicationPanel = React.lazy(() => import('./Admin_superior/Application').then(module => ({ default: module.ApplicationPanel })));
const DummyScript = React.lazy(() => import('./pages/Projects/DummyScript'));

/* Metrics */
const Metrics = React.lazy(() => import('./pages/Projects/Metrics').then(module => ({ default: module.Metrics })));
/* help online */
const VideoTutorial = React.lazy(() => import('./pages/Help/videotutorial').then(module => ({ default: module.VideoTutorial })));
const AudioMatePdfGuide = React.lazy(() => import('./pages/Help/pdfguide').then(module => ({ default: module.AudioMatePdfGuide })));
const WhatsNewModule = React.lazy(() => import('./pages/Help/whatsNew').then(module => ({ default: module.WhatsNew })));

// licence that we have always had
registerLicense('ORg4AjUWIQA/Gnt2XFhhQlJHfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTH5WdEVjXn1YdHRXQmhfWkdx');

$(window).on("resize", function(e) {

    const current = $(window).height();
    const breakdownHeight = current - 305;
    const projectlistHeight = current - 250;

    const bdbuilderHeight = current - 320; 
    const resourceappAppHeight = current - 290; 
    const resourceappActorHeight = current - 290; 
    const resourcegroupsHeight = current - 290;
    const resourcerecstudiosHeight = current - 260;
    const rulesHeight = current - 255;
    const ganttHeight = current - 300;
    const amsites = current - 290;

    document.documentElement.style.setProperty(`--div-height-breakdown`, breakdownHeight + 'px');
    document.documentElement.style.setProperty(`--div-height-breakdown-grid`, (breakdownHeight - 140) + 'px');

    document.documentElement.style.setProperty(`--div-height-breakdown`, breakdownHeight + 'px');
    document.documentElement.style.setProperty(`--div-height-projectlist`, projectlistHeight + 'px');
    
    document.documentElement.style.setProperty(`--div-height-bdbuilder`, bdbuilderHeight + 'px');
    document.documentElement.style.setProperty(`--div-height-resourceapp`, resourceappAppHeight + 'px');
    document.documentElement.style.setProperty(`--div-height-resourceactors`, resourceappActorHeight + 'px');
    document.documentElement.style.setProperty(`--div-height-resourcegroups`, resourcegroupsHeight + 'px');
    document.documentElement.style.setProperty(`--div-height-resourcerecstudios`, resourcerecstudiosHeight + 'px');
    document.documentElement.style.setProperty(`--div-height-rules`, rulesHeight + 'px');
    document.documentElement.style.setProperty(`--div-height-ganttPlanner`, ganttHeight + 'px');
    document.documentElement.style.setProperty(`--div-height-amsites`, amsites + 'px');
    document.documentElement.style.setProperty(`--div-height-amclients`, amsites + 'px');
    scriptControlHeight(current);
    mediaControlHeight();

});

function RedirectToCurrentUser(props) {
    const location = useLocation();

    if (location.pathname.startsWith("/u/")) return <NotFound />;

    return (
        <Navigate
            to={`/u/${props.userId}${location.pathname}${location.search}`}
            replace
        />
    );
}

function UserGuard({ userId }) {
    const { userId: routeUserId } = useParams();
    const location = useLocation();

    if (userId !== parseInt(routeUserId)) {
        const newPath = location.pathname.replace(
            /^\/u\/[^/]+/,
            `/u/${userId}`
        );

        return <Navigate to={`${newPath}${location.search}`} replace />;
    }

    return <Outlet />;
}

function App() {

    const [actor, setActor] = useState(false);
    const [userData, setUserData] = useState(null);
    const [showActorScriptPortal, setShowActorScriptPortal] = useState(false);
    /* electron mode */
    const amKRASTRef = useRef(null);
    const amKRASTHeaderRef = useRef(null);

    useEffect(() => {     
        if(userData && userData !== 'deactivated') {
            const datadog = userData.datadog;
            window.DD_RUM?.setUser?.(datadog);
        }    
    }, [userData])

    useEffect(() => {
        setUserDataFn(setUserData);
    }, [])

    if(!userData) return null;

    if(userData === 'deactivated' || userData === 'error') {
        const msg = userData === 'deactivated' ? 'Your account is deactivated.' : 'Error verifying account.';
        return (
            <>
                <div className="container">
                    <div className="d-flex justify-content-center py-4">
                        <a href={window.location.href} className="logo d-flex align-items-center w-auto">
                            <img src="/assets/img/kantan-audiomate_logo-color.png" alt="" />
                        </a>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-lg-6 col-md-6 d-flex flex-column align-items-center justify-content-center">
                            <div className="d-flex justify-content-center">
                                <div className="alert alert-danger alert-dismissible fade show" role="alert">
                                    <h5>Warning!</h5>
                                    <div>{msg}</div>
                                    <div className="mt-2">Contact AudioMate support to get your account back: <a href="mailto:audiomate.support@keywordsstudios.com">
                                        audiomate.support@keywordsstudios.com
                                    </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <a style={{textAlign: 'center', textDecoration: 'underline'}} href='/' onClick={(e) => {
                            e.preventDefault();
                            logOut();
                        }} >Go back to Log-In</a>
                    </div>
                </div>
            </>
        );
    }

    return (
        <>  
            <InfoProvider initialData={userData} amKRASTRef={amKRASTRef} amKRASTHeaderRef={amKRASTHeaderRef}>
                <ActorScriptContextProvider>
                    <PronunciationsContextProvider>             
                        <SpellCheckContextProvider>  
                            <Router>
                                {!actor && <Header/>}
                                {!actor && <MenuLeft />}
                                <div id="audiomatecontrol">
                                    <Suspense fallback={<div>Loading...</div>}>
                                        <Routes>
                                            {!actor && 
                                            <Route exact path="/u/:userId" element={<UserGuard userId={userData.id}/>}>         
                                                <Route index element={<ProjectsShow />} />
                                                <Route exact path="userdata/:section?" element={<ProfileSettings/>}/>
                                                <Route exact path="projects/:title?" element={<ProjectsShow/>}/>
                                                <Route path="uploads/:uploadinfo?" 
                                                    element={
                                                        <Protected permissions={['SourceUploadFiles', 'TargetUploadFiles']}>
                                                            <UploadAssets/>
                                                        </Protected>
                                                    }
                                                />
                                                <Route path="downloads/:downloadinfo?" 
                                                    element={
                                                        <Protected permissions={['SourceDownloadFiles', 'TargetDownloadFiles']}>
                                                            <DowloadAssets/>
                                                        </Protected>     
                                                    }
                                                />
                                                <Route path="metrics" 
                                                    element={
                                                        <Protected onlyInternal={true}>
                                                            <Metrics/>
                                                        </Protected>
                                                    }     
                                                />
                                                <Route path="videos" element={<VideoPlayer/>}/>
                                                <Route exact path="projectsdetails/:id/overview"
                                                    element={
                                                        <Protected permissions={['view_Overview']}>
                                                                <ProjectsOverview/>
                                                        </Protected>
                                                    }
                                                />
                                                <Route exact path="projectsdetails/:id/breakdown" 
                                                    element={
                                                        <Protected permissions={['view_Breakdown']}>
                                                                <ProjectsBD/>
                                                        </Protected>
                                                    }
                                                />
                                                <Route exact path="redirectdb/:id" element={<ProjectBreakdownfakeLink/>}/>
                                                <Route exact path="qatags" 
                                                    element={
                                                        <Protected permissions={['showQATagsModule']}>
                                                            <QATags/>
                                                        </Protected>
                                                    }
                                                />
                                                <Route exact path="xloc"  
                                                    element={
                                                        <Protected permissions={['xlocModule']}>
                                                            <XLOCApi/>                                                
                                                        </Protected>
                                                    }
                                                />
                                                <Route exact path="projectsdetails/:id/script" 
                                                    element={
                                                        <Protected permissions={['view_ScriptBase']}>
                                                            <ProjectsScript data={{showActorScriptPortal, setShowActorScriptPortal}}/>  
                                                        </Protected>        
                                                    }
                                                /> 
                                                <Route exact path="projectsdetails/:id/delivery" 
                                                    element={
                                                        <Protected permissions={['deliveryDashboard']}>
                                                            <DeliveryDashboard />  
                                                        </Protected>        
                                                    }
                                                /> 
                                                <Route exact path="projectsdetails/:id/dummyscript" 
                                                    element={
                                                        <Protected permissions={['view_ScriptBase']}>
                                                            <DummyScript/>  
                                                        </Protected>        
                                                    }
                                                /> 
                                                <Route exact path="projectsdetails/:id/excel"
                                                    element={
                                                        <Protected permissions={['view_ExcelModule']}>
                                                            <ProjectScriptExcel/>
                                                        </Protected>      
                                                    }
                                                />
                                                <Route exact path="projectsdetails/:id/gantt" 
                                                    element={
                                                        <Protected permissions={['view_GantChart']}>
                                                            <ProjectGant/>
                                                        </Protected>      
                                                    }
                                                />
                                                <Route exact path="projectsdetails/:id/bdbuilder" 
                                                    element={
                                                        <Protected permissions={['view_BreakDownBuilder']}>
                                                            <ProjectBDBuilder/>
                                                        </Protected>        
                                                    }
                                                />
                                                <Route path="projectsdetails/:id/actors" 
                                                       element={
                                                           <Protected permissions={['actorsContracts']}>
                                                               <ProjectActors/>
                                                           </Protected>
                                                       } 
                                                />
                                                <Route exact path="projectsdetails/:id/production" 
                                                    element={
                                                        <Protected permissions={['view_Trello']}>
                                                            <TrelloProduction/>
                                                        </Protected>     
                                                    }
                                                />
                                                <Route exact path="projectsdetails/:id/sessions"
                                                    element={
                                                        <Protected permissions={['ShareSession']}>
                                                            <RecordingSessions />
                                                        </Protected>
                                                    }
                                                />
                                                {/*
                                                <Route exact path="/projectsdetails/:id/medianewmedia" 
                                                    element={
                                                        <Protected permissions={['view_Media']}>
                                                            <MediaLibrary/>
                                                        </Protected>
                                                    }
                                                /> 
                                                */}
                                                <Route exact path="projectsdetails/:id/inspector" 
                                                    element={
                                                        <Protected permissions={['view_Media']}>
                                                            <MediaLibrary2/>
                                                        </Protected>        
                                                    }
                                                />
                                                <Route exact path="projectsdetails/:id/explorer" 
                                                    element={
                                                        <Protected permissions={['manageAssets']}>
                                                            <FileManager/>
                                                        </Protected>        
                                                    }
                                                />
                                                {/* resources */}
                                                <Route exact path="admin" 
                                                    element={
                                                        <Protected permissions={['createAccount']}>
                                                            <AdminHomePage/>
                                                        </Protected>
                                                    }
                                                />
                                                <Route exact path="appresources" 
                                                    element={
                                                        <Protected permissions={['createAccount']}>
                                                            <ApplicationUsers/>
                                                        </Protected>
                                                    }
                                                />
                                                <Route exact path="sites" 
                                                    element={
                                                        <Protected permissions={['manageSites']}>
                                                            <AMSites/>
                                                        </Protected>
                                                    }
                                                />
                                                <Route exact path="clients" 
                                                    element={
                                                        <Protected permissions={['manageClients']}>
                                                            <AMClients/>
                                                        </Protected> 
                                                    }
                                                />
                                                <Route exact path="languages" 
                                                    element={
                                                    <Protected permissions={['manageLanguages']}>
                                                            <AMLanguages/>
                                                        </Protected> 
                                                    }
                                                />
                                                <Route exact path="franchises" 
                                                    element={
                                                        <Protected permissions={['manageFranchise']}>
                                                            <AMFranchises/>
                                                        </Protected>
                                                    }
                                                />
                                                <Route exact path="roles" 
                                                    element={
                                                        <Protected permissions={['UITemp']}>
                                                            <AMRoles/>
                                                        </Protected>
                                                    }
                                                />
                                                {/*<Route exact path="ec2Win" 
                                                    element={
                                                        <Protected permissions={['UITemp']}>
                                                            <ElectronStreamViewer/>
                                                        </Protected>
                                                    }
                                                />*/}
                                                <Route exact path="prodresources" 
                                                    element={
                                                        <Protected permissions={['createActors']}>
                                                            <ProductionUsers/>
                                                        </Protected>   
                                                    }
                                                />
                                                <Route exact path="teams" 
                                                    element={
                                                        <Protected permissions={['createTeams']}>
                                                            <GroupsManagements/>
                                                        </Protected>  
                                                    }
                                                />
                                                <Route exact path="recbooths" 
                                                    element={
                                                        <Protected permissions={['manageRecBooths']}>
                                                            <RecordingStudios/>
                                                        </Protected>   
                                                    }
                                                />
                                                <Route exact path="bankholidays" 
                                                    element={
                                                        <Protected permissions={['bankHolidays']}>
                                                            <BankHolidays/>
                                                        </Protected> 
                                                    }
                                                />
                                                <Route exact path="tasktypes" 
                                                    element={
                                                        <Protected permissions={['UITemp']}>
                                                            <AMTasksType/>
                                                        </Protected> 
                                                    }
                                                />
                                                <Route exact path="pronglossaries" 
                                                    element={
                                                        <Protected permissions={['setPronunciationGlossaries']}>
                                                            <PronunciationGlossaries/>
                                                        </Protected>
                                                    }
                                                />
                                                <Route exact path="scheduler" 
                                                    element={
                                                        <Protected permissions={['view_Scheduler']} externalSite={[0]}>
                                                            <SchedulerContainer/>
                                                        </Protected>  
                                                    }
                                                />
                                                <Route exact path="scheduler2" 
                                                    element={
                                                        <Protected permissions={['view_Scheduler2']} externalSite={[0]}>
                                                            <SchedulerContainer2/>
                                                        </Protected>  
                                                    }
                                                />
                                                <Route exact path="mydashboard" element={
                                                    <Protected permissions={['myDashboard']}>
                                                        <MyDashboard/>
                                                    </Protected>
                                                } />
                                                <Route exact path="kpis" 
                                                    element={
                                                        <Protected permissions={['view_kpis']}>
                                                            <KPIs/>
                                                        </Protected>  
                                                    }
                                                />
                                                {/* resources temporany */}
                                                <Route exact path="rolePermissions" 
                                                    element={
                                                        <Protected permissions={['UITemp']}>
                                                            <RolesPermission/>
                                                        </Protected>  
                                                    }
                                                />
                                                <Route exact path="application" 
                                                    element={
                                                        <Protected permissions={['UITemp']}>
                                                            <ApplicationPanel/>
                                                        </Protected>
                                                    }
                                                />
                                                <Route exact path="spreedsheet" 
                                                    element={
                                                        <Protected permissions={['UITemp']}>
                                                            <ExcelModule/>
                                                        </Protected>
                                                    }
                                                />
                                                <Route exact path="s3manager" 
                                                    element={
                                                        <Protected permissions={['UITemp']}>
                                                            <S3Manager/>
                                                        </Protected> 
                                                    }
                                                />
                                                <Route exact path="whatsnew" 
                                                    element={
                                                        <Protected permissions={['UITemp']}>
                                                            <WhatsNewModule/>
                                                        </Protected> 
                                                    }
                                                />
                                                <Route exact path="logs" 
                                                    element={
                                                        <Protected permissions={['UITemp']}>
                                                            <AMLogs/> 
                                                        </Protected>  
                                                    }
                                                />
                                                <Route exact path="chatai" 
                                                    element={
                                                        <Protected permissions={['UITemp']}>
                                                            <ChatGPT/>
                                                        </Protected>  
                                                    }
                                                />
                                                <Route exact path="help" element={<VideoTutorial/>}/>
                                                <Route exact path="documentation/:id" element={<AudioMatePdfGuide/>}/>
                                            </Route>
                                            }

                                            <Route exact path="/actorscript" 
                                                element={
                                                    <Protected permissions={['view_ScriptBase']}>
                                                        <ActorScriptWindow data={{set:setActor}}/>
                                                    </Protected>
                                                }
                                            />

                                                <Route exact path="/agenda"
                                                    element={<AgendaWindow data={{set:setActor}}/>}
                                                />
                                            <Route exact path="/AudiomatePlayer" element={<PlayerDetachableAudio />}/>
                                            <Route exact path="/AudioMateVPlayer" element={<PlayerDetachableVideo /*data={{set:setPlayer}}*//>}/>
                                            {/*<Route path="*" element={<NotFound />} />*/}
                                            <Route exact path="*" element={<RedirectToCurrentUser userId={userData.id}/>} />
                                        </Routes>
                                    </Suspense>
                                </div>
                                {/* electron mode */}
                                <AMKRAST ref={amKRASTRef} />
                            </Router>
                        </SpellCheckContextProvider>
                    </PronunciationsContextProvider>
                </ActorScriptContextProvider>
                <FloatingWindowLauncher/>
            </InfoProvider>        
        </>
    )
  
}

export default App;
